/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
    },
    registered() {
      console.log('CRM Service worker has been registered.');
    },
    cached() {
      console.log('CRM  Content has been cached for offline use.')
    },
    updatefound() {
      console.log('CRM  New content is downloading.')
    },
    updated(registration) {
      console.log('CRM  New content is available; please refresh.')
      location.reload();
    },
    offline() {
      console.log('CRM  No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('CRM  Error during service worker registration:', error)
    }
  })
}
